import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Dashboard from "../../pages/Dashboard/Dashboard";
import AuthCallback from "../Router/AuthCallback";
import { appInsights, reactPlugin, browserHistory } from '../../utils/appInsights'; 
import { withAITracking } from '@microsoft/applicationinsights-react-js'; 
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import Projects from "../../pages/Projects/Projects";
import { getRedirecturl } from "../../utils/oidcConfig";
import Logout from "../../hooks/logout";

const DashboardWithTracking = withAITracking(reactPlugin, Dashboard);

const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("access_token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/logout');
    }
  // else{
    
  //   window.location.href=getRedirecturl() as string +"/dashboard";
  // }
   
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) {
    return children;
  }
  return null;
};

export const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
      <Route path="/auth-callback" element={<AuthCallback />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardWithTracking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/project"
          element={
            <ProtectedRoute>
              <Projects />
            </ProtectedRoute>
          }
        />
         <Route path="/logout" element={<Logout />} />
      </Routes>
    </BrowserRouter>
  );
};
